$(document).ready(function(){
    'use strict';
    const slider = $('.slider')

    //Настройки слайдера
    if (slider !== undefined) {
        slider.map(function () {
            const arrowNext = $(this).parents('.info-block__el').find('.slider-arrows__arrow--next')
            const arrowPrev = $(this).parents('.info-block__el').find('.slider-arrows__arrow--prev')

            $(this).slick({
                infinite: true,
                arrows: true,
                nextArrow: arrowNext,
                prevArrow: arrowPrev,
                speed: 300,
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                responsive: [
                    // {
                    //     breakpoint: 767,
                    //     settings: {
                    //         variableWidth: true,
                    //     }
                    // },
                    // {
                    //     breakpoint: 480,
                    //     settings: {
                    //         slidesToShow: 1,
                    //         slidesToScroll: 1
                    //     }
                    // }
                ]
            });
        })
    }
});
